export default {
  category_name: 'Acheter une carte cadeau',
};
